module.exports = __webpack_public_path__ + "adccb46d.svg";